import React from "react";

export default function SQLServer_DIFFERENCE() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_DIFFERENCE</h1>
      <p>This is the SQLServer_DIFFERENCE component generated from the SQL JSON.</p>
    </div>
  );
}
